import React, { Component, Fragment } from "react";
import { graphql } from "gatsby";
import Layout from 'layout';
import { Helmet } from "react-helmet";
import ReactPaginate from 'react-paginate';

import Table from 'components/Rate/Table';

class rate extends Component {
    componentWillMount() {
        this.pagination();
        this.pageCount();
    }

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            datasPerPage: 5,
            allDirectusRateList: this.props.data.allDirectusRateList,
            currentDatas : this.props.data.allDirectusRateList,
        }
    }

    pagination = () => {
        const indexOfLastData = this.state.currentPage * this.state.datasPerPage;
        const indexOfFirstData = indexOfLastData - this.state.datasPerPage;
        const currentDatas = !this.state.allDirectusRateList ? null : this.state.allDirectusRateList.edges.slice(indexOfFirstData, indexOfLastData);

        let self = this;
        self.setState({
            currentDatas: {
                edges: currentDatas
            }
        })
    }

    pageCount = () => {
        let self = this;

        if (!this.state.allDirectusRateList) {
            self.setState({
                pageCount : 0
            })
        }
        else
        {
            self.setState({
                pageCount : Math.ceil(this.state.allDirectusRateList.edges.length / this.state.datasPerPage)
            })
        }

    }
    
    filter = (e) => {
        let data = this.props.data.allDirectusRateList.edges;
        let self = this;

        let update = data.filter((item) => {
            return item.node.gacha_name.toLowerCase().indexOf(
                e.target.value.toLowerCase()) !== -1;
        })

        self.setState({
            allDirectusRateList: {
                edges: update
            },
            currentPage : 1
        }, () => {
            this.pagination(),
            this.pageCount()
        })
    }

    handlePageClick = (data) => {
        let selected = data.selected + 1;
        let self = this;

        self.setState({
            currentPage : selected
        }, () => {
            this.pagination()
        })
    }

    render() {
        return (
            <Layout>
                <Helmet>
                    <title>Rate Gacha Speed Drifters</title>
                    <meta property="og:url" content={this.props.location.href} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="RATE GACHA" />
                    <meta property="og:description" content="RATE GACHA" />
                </Helmet>
                <div id="rate">
                    <div className="article-container">
                        <div className="article-container__title">RATE GACHA</div>
                        <div className="article-container__search">
                            <span>Search Gacha Name : </span><input type="text" onChange={this.filter} />
                        </div>
                        <div className="article-container__content">
                            <Table data={this.state.currentDatas} />
                        </div>
                    </div>
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={this.state.pageCount}
                        forcePage={this.state.currentPage - 1}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </div>
            </Layout>
        );
    }
}

export default rate;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
    query RateQuery($lang_id: Int!)
    {
        allDirectusRateList(filter: {
            region: {
            eq : $lang_id
            }
        }) {
            edges {
                node {
                    region
                    gacha_name
                    details {
                        data {
                            content
                            rate
                        }
                    }
                }
            }
        }
    }
`;